<!-- FORMULARIO PARA AGREGAR CONDICIONES A PROMOCIONES-->
<form [formGroup]="agregarFormCondicion">    
    <div class="row">
      <div class="col-lg-12">
        <app-lfsa-input [control]="this.agregarFormCondicion.get('id_promo')" [id]="'id_promo'"
          [isReadOnly]="true" [label]="'ID PROMO'" formControlName="id_promo" type="text">
        </app-lfsa-input>
      </div>
  
      <div class="col-lg-12 mb-5">
        <label for="id_sub_canal">Seleccione Conidición</label>
        <select class="form-control" formControlName="id_sub_canal" id="id_sub_canal">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of comboList" [value]="data.idTarCanal">{{ data.dscaGrupoCanal }}</option>
        </select>
      </div>
    </div>
  
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
      [formularioValido]="(!agregarFormCondicion.invalid) ? false : true"
      [textBoton]="'Guardar'" class="row">
    </app-lfsa-botones-formulario>
</form>
